<script>
  export let value;
  export let lang = undefined;
</script>

<a href={value.link} class='ticket'
  class:ticket-green={value.color === 'green'}
  class:ticket-orange={value.color === 'orange'}
  class:ticket-blue={value.color === 'blue'}
  class:ticket-red={value.color === 'red'}
  class:ticket-yellow={value.color === 'yellow'}>

  <div class='ticket-banner'>
    <img class='ticket-banner-image' src='img/static/ticket/{value.banner}.jpg' alt='Ticket banner'/>
  </div>

  <div class='ticket-box'>
    <div class='ticket-box-logo'>
      <img class='ticket-box-logo-image' src='img/static/symbol.svg' alt='Eurobaseball 2023 logo'/>
    </div>

    <div class='ticket-box-content'>
      <div class='ticket-box-content-text'> {value.label[lang]} </div>
    </div>

    <div class='ticket-box-teams'>
      {#each value.teams as team}
        <div class='ticket-box-teams-team'>
          <!-- svelte-ignore a11y-missing-attribute -->
          <img class='ticket-box-teams-team-image' src='img/static/flag/{team}.svg'/>
        </div>
      {/each}
    </div>
  </div>

  <div class='ticket-graphic'>
    <img class='ticket-graphic-image' src='img/static/ticket/graphic.jpg' alt='Ticket graphic'/>
  </div>
</a>

<style>
  .ticket {
    position: relative;

    display: flex;

    width: 100%;
    height: 90px;

    border-radius: 5px;

    text-decoration: none;

    color: inherit;

    transition: box-shadow 1s ease-in-out, transform 1s ease-in-out;
  }

  .ticket:hover {
    box-shadow: 0px 0px 10px 0px var(--grey-6);

    transform: scale(1.025);
  }

  .ticket-banner {
    position: absolute;

    width: calc(100% - 15px);
    height: 100%;
  }

  .ticket-banner-image {
    width: 100%;
    height: 100%;

    border-radius: 5px 0px 0px 5px;

    object-fit: cover;
  }

  .ticket-box {
    position: absolute;

    display: flex;
    gap: 15px;

    width: calc(100% - 60px);
    height: calc(100% - 30px);

    padding: 15px 15px 15px 30px;

    border-radius: 5px 0px 0px 5px;

    background: rgba(10, 29, 49, 0.8);
  }

  .ticket-box-logo {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 60px;
    height: 60px;
  }

  .ticket-box-logo-image {
    max-width: 100%;
    max-height: 100%;
  }

  .ticket-box-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    text-transform: uppercase;

    font-family: var(--font-secondary-ultra);
    font-size: 20px;

    letter-spacing: 1.2px;
  }

  .ticket-box-content-text {
    text-align: center;
  }

  .ticket-box-teams {
    position: absolute;
    bottom: 5px;
    right: 5px;

    display: flex;
    gap: 5px;
  }

  .ticket-box-teams-team {
    height: 15px;
  }

  .ticket-box-teams-team-image {
    height: 100%;
  }

  .ticket-graphic {
    position: absolute;
    right: 0px;

    width: 15px;
    height: 100%;
  }

  .ticket-graphic-image {
    width: 100%;
    height: 100%;

    border-radius: 0px 5px 5px 0px;

    object-fit: cover;
  }

  .ticket-green .ticket-box-content {
    color: var(--green);
  }

  .ticket-orange .ticket-box-content {
    color: var(--orange);
  }

  .ticket-blue .ticket-box-content {
    color: var(--blue);
  }

  .ticket-red .ticket-box-content {
    color: var(--red);
  }

  .ticket-yellow .ticket-box-content {
    color: var(--yellow);
  }

  :global(body.dark) .ticket-banner-image {
    filter: brightness(88%);
  }

  :global(body.dark) .ticket:hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  :global(body.dark) .ticket-box-logo-image {
    filter: brightness(88%);
  }

  :global(body.dark) .ticket-box {
    background: rgba(8, 25, 43, 0.8);
  }

  :global(body.dark) .ticket-box-logo-image {
    filter: brightness(88%);
  }

  :global(body.dark) .ticket-box-teams-team-image {
    filter: brightness(88%);
  }

  :global(body.dark) .ticket-graphic-image {
    filter: brightness(88%);
  }

  :global(body.dark) .ticket-green .ticket-box-content {
    color: var(--green-dark);
  }

  :global(body.dark) .ticket-orange .ticket-box-content {
    color: var(--orange-dark);
  }

  :global(body.dark) .ticket-blue .ticket-box-content {
    color: var(--blue-dark);
  }

  :global(body.dark) .ticket-red .ticket-box-content {
    color: var(--red-dark);
  }

  :global(body.dark) .ticket-yellow .ticket-box-content {
    color: var(--yellow-dark);
  }
</style>
